import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from '@openclassrooms/translations';
import { getCurrentUserFromGlobal } from 'lib/current-user';

declare const LANG_HASHES: Record<string, string>;

const [, scriptUrl] = (document.currentScript as HTMLScriptElement)?.src.match(/(^.*)\//) || [
  undefined,
  DEFAULT_LANGUAGE,
];

const LOCAL_STORAGE_KEY = 'lang';
export const LANG_REGEXP = new RegExp(`^/(${SUPPORTED_LANGUAGES?.join('|')})/`);

const isForum = () => {
  const { pathname } = window.location;
  return pathname.startsWith('/forum');
};

const checkLangSupport = (lang?: string | null) =>
  lang && SUPPORTED_LANGUAGES.includes(lang) ? lang : DEFAULT_LANGUAGE;

function getLocaleFromUrl() {
  const firstSegmentPath = window.location.pathname.split('/')[1];

  if (firstSegmentPath !== 'us') {
    return null;
  }

  return {
    lang: 'en',
    country: 'US',
  };
}

export const setLang = (lang: string) => {
  localStorage.setItem(LOCAL_STORAGE_KEY, checkLangSupport(lang));
};

export const getLang = () => {
  if (isForum()) {
    return 'fr';
  }

  const { lang } = getLocaleFromUrl() ?? {};
  const urlLang = checkLangSupport(window.location.pathname.match(LANG_REGEXP)?.[1]);
  const localStorageLang = checkLangSupport(localStorage.getItem(LOCAL_STORAGE_KEY));
  const navigatorLang = checkLangSupport(navigator.language.split('-')[0]);
  return lang || urlLang || localStorageLang || navigatorLang || DEFAULT_LANGUAGE;
};

const getCountry = () => {
  const { country: urlCountry } = getLocaleFromUrl() ?? {};
  const currentUser = getCurrentUserFromGlobal();
  const country = currentUser ? currentUser.country : '';

  return urlCountry || country;
};

const getConfiguration = () => {
  const lang = getLang();
  const hashes = typeof LANG_HASHES === 'undefined' ? {} : LANG_HASHES;

  return {
    fetchUrl: `${scriptUrl}/langs`,
    fileHash: hashes[lang] ?? Date.now(),
    lang,
    country: getCountry(),
  };
};

export default getConfiguration;
